module.exports = __webpack_public_path__ + "img/fnaim.1b4f4f60.jpg";